import { CommonModule } from '@angular/common';
import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AccountService } from '../../account/account.service';

@Component({
  selector: 'lib-company-info',
  templateUrl: './company-info.component.html',
  styleUrls: ['./company-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslateModule, CommonModule],
})
export class CompanyInfoComponent {
  private readonly accountService = inject(AccountService);

  public account = this.accountService.account;

  // constructor() {  }
}
